import React from 'react'
import { Link } from 'react-router-dom'
export default function Markteing() {
  return (
    <>
 <main>
      
      <div className="hero-arera course-item-height" data-background="assets/img/slider/course-slider.jpg" style={{ backgroundImage: " url(assets/img/slider/digital.webp)" }}>
         <div className="container">
            <div className="row">
               <div className="col-xl-12">
                  <div className="hero-course-1-text">
                     <h2>Marketing</h2>
                  </div>
                  <div className="course-title-breadcrumb">
                     <nav>
                        <ol className="breadcrumb">
                           <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                           <li className="breadcrumb-item"><span>Courses</span></li>
                        </ol>
                     </nav>
                  </div>
               </div>
            </div>
         </div>
      </div>
      

      
    
      <div className="container">
        
                <div className="row" style={{marginTop:"2rem"}}>
                    <div className="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-12 col-sm justify-content-center mb-30">
                        <div className="section-title mb-20 text-center">
                            <h2>Choose your favorite <span className="down-mark-line">courses </span></h2>
                        </div>
                    </div>
                </div>

                </div>
      
      <div className="course-content-area pb-90">
         <div className="container">
            <div className="row ">
            
               <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="row">
                     <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="academic-box mb-30">
                           <div className="academic-thumb">
                              <img src="assets/img/course/academi-course-2.jpg" alt="image not found"/>
                           </div>
                           <div className="academic-content">
                              <div className="academic-content-header">
                                 <Link target='_blank' to="https://wa.me/9617124507">
                                    <h3> GOOGLE'S ADWORDS FUNDAMENTAL COURSE</h3>
                                 </Link>
                              </div>
                              <div className="academic-body">
                              
                                 <p>Helping employees gain skills and development often take a back seat to business</p>
                              </div>
                              <div className="academic-footer">
                                 <div className="coursee-clock">
                                    <i className="flaticon-clock"></i><span>4 Years</span>
                                 </div>
                                 <div className="course-creadit">
                                    <i className="flaticon-menu-1"></i><span>8 Credit</span>
                                 </div>
                                 <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="academic-box mb-30">
                           <div className="academic-thumb">
                              <img src="assets/img/course/academi-course-3.jpg" alt="image not found"/>
                           </div>
                           <div className="academic-content">
                              <div className="academic-content-header">
                                 <Link target='_blank' to="https://wa.me/9617124507">
                                    <h3> GOOGLE DISPLAY ADVERTISING COURSE</h3>
                                 </Link>
                              </div>
                              <div className="academic-body">
                           
                                 <p>Helping employees gain skills and development often take a back seat to business</p>
                              </div>
                              <div className="academic-footer">
                                 <div className="coursee-clock">
                                    <i className="flaticon-clock"></i><span>4 Years</span>
                                 </div>
                                 <div className="course-creadit">
                                    <i className="flaticon-menu-1"></i><span>8 Credit</span>
                                 </div>
                                 <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="academic-box mb-30">
                           <div className="academic-thumb">
                              <img src="assets/img/course/academi-course-4.jpg" alt="image not found"/>
                           </div>
                           <div className="academic-content">
                              <div className="academic-content-header">
                                 <Link target='_blank' to="https://wa.me/9617124507">
                                    <h3> GOOGLE MOBILE ADVERTISING COURSE</h3>
                                 </Link>
                              </div>
                              <div className="academic-body">
                                
                                 <p>Helping employees gain skills and development often take a back seat to business</p>
                              </div>


                              
                              <div className="academic-footer">
                                 <div className="coursee-clock">
                                    <i className="flaticon-clock"></i><span>4 Years</span>
                                 </div>
                                 <div className="course-creadit">
                                    <i className="flaticon-menu-1"></i><span>8 Credit</span>
                                 </div>
                                 <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="academic-box mb-30">
                           <div className="academic-thumb">
                           <img src="assets/img/portfilo/course-img-01.jpg" alt="course-img"/>
                           </div>
                           <div className="academic-content">
                              <div className="academic-content-header">
                                 <Link target='_blank' to="https://wa.me/9617124507">
                                    <h3> GOOGLE VIDEO ADVERTISING COURSE</h3>
                                 </Link>
                              </div>
                              <div className="academic-body">
                              
                                 <p>Helping employees gain skills and development often take a back seat to business</p>
                              </div>
                              <div className="academic-footer">
                                 <div className="coursee-clock">
                                    <i className="flaticon-clock"></i><span>4 Years</span>
                                 </div>
                                 <div className="course-creadit">
                                    <i className="flaticon-menu-1"></i><span>8 Credit</span>
                                 </div>
                                 <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="academic-box mb-30">
                           <div className="academic-thumb">
                           <img src="assets/img/portfilo/course-img-03.jpg" alt="course-img"/>
                           </div>
                           <div className="academic-content">
                              <div className="academic-content-header">
                                 <Link target='_blank' to="https://wa.me/9617124507">
                                    <h3> GOOGLE MY BUSINESS COURSE</h3>
                                 </Link>
                              </div>
                              <div className="academic-body">
                               
                                 <p>Helping employees gain skills and development often take a back seat to business</p>
                              </div>
                              <div className="academic-footer">
                                 <div className="coursee-clock">
                                    <i className="flaticon-clock"></i><span>4 Years</span>
                                 </div>
                                 <div className="course-creadit">
                                    <i className="flaticon-menu-1"></i><span>8 Credit</span>
                                 </div>
                                 <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="academic-box mb-30">
                           <div className="academic-thumb">
                           <img src="assets/img/portfilo/course-img-06.jpg" alt="course-img"/>
                           </div>
                           <div className="academic-content">
                              <div className="academic-content-header">
                                 <Link target='_blank' to="https://wa.me/9617124507">
                                    <h3> BEST TOOLS AND PRACTICES BY GOOGLE</h3>
                                 </Link>
                              </div>
                              <div className="academic-body">
                               
                                 <p>Helping employees gain skills and development often take a back seat to business</p>
                              </div>
                              <div className="academic-footer">
                                 <div className="coursee-clock">
                                    <i className="flaticon-clock"></i><span>4 Years</span>
                                 </div>
                                 <div className="course-creadit">
                                    <i className="flaticon-menu-1"></i><span>8 Credit</span>
                                 </div>
                                 <Link className="edo-course-sec-btn"  to="https://wa.me/9617124507">Apply now</Link>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="academic-box mb-30">
                           <div className="academic-thumb">
                           <img src="assets/img/portfilo/course-img-08.jpg" alt="course-img"/>
                           </div>
                           <div className="academic-content">
                              <div className="academic-content-header">
                                 <Link target='_blank' to="https://wa.me/9617124507">
                                    <h3> SHOPPING ADS CERTIFICATION COURSE BY GOOGLE</h3>
                                 </Link>
                              </div>
                              <div className="academic-body">
                               
                                 <p>Helping employees gain skills and development often take a back seat to business</p>
                              </div>
                              <div className="academic-footer">
                                 <div className="coursee-clock">
                                    <i className="flaticon-clock"></i><span>4 Years</span>
                                 </div>
                                 <div className="course-creadit">
                                    <i className="flaticon-menu-1"></i><span>8 Credit</span>
                                 </div>
                                 <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               
               </div>
            </div>
         </div>
      </div>
      

   </main>
    </>
  )
}
